import DatePickerView from '../date-picker-view/locale/sv_SE';
import DatePicker from '../date-picker/locale/sv_SE';
import InputItem from '../input-item/locale/sv_SE';
import Pagination from '../pagination/locale/sv_SE';
import Picker from '../picker/locale/sv_SE';
import SearchBar from '../search-bar/locale/sv_SE';
import Menu from '../menu/locale/sv_SE';
import PullToRefresh from '../pull-to-refresh/locale/sv_SE';
export default {
    locale: 'sv',
    Pagination,
    DatePicker,
    DatePickerView,
    InputItem,
    Picker,
    SearchBar,
    Menu,
    PullToRefresh,
};
